import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, get, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface PickUpNotificationApiParameter extends ApiParameter {
    EmailPreference?: boolean;
    ShowCheckoutModal?: boolean;
    Email?: string;
    CartId?: string;
    isPage?: boolean;
}

export interface GetPickUpNotificationApiParameter extends ApiParameter {
    cartid: string;
}

export interface PickupNotificationApiResponse {
    emailPreference: boolean;
    showAccountLink: true;
    showCheckoutModal: boolean;
}

export interface PickupNotificationModel extends BaseModel {
    pickupNotification: PickupNotificationApiResponse;
}

const url = "/api/v1/PickupNotification";

export async function getPickupNotification(
    parameter: GetPickUpNotificationApiParameter,
): Promise<ServiceResult<PickupNotificationModel>> {
    try {
        const getPickupNotification = await get<PickupNotificationModel>(
            `${url}/GetPickupNotification`,
            parameter as any,
        );
        return {
            result: getPickupNotification,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function setPickUpNotification(
    parameter: PickUpNotificationApiParameter,
): Promise<ServiceResult<PickupNotificationModel>> {
    try {
        const pickupNotification = await post<PickupNotificationModel>(`${url}`, parameter as any);
        return {
            result: pickupNotification,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
